import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function PainSection() {
  return <section className="py-20 md:py-28 px-6 bg-base" data-id="element-448">
      <div className="max-w-copy mx-auto" data-id="element-449">
        {/* Section label */}
        <FadeIn data-id="element-450">
          <div className="flex items-center gap-4 mb-14" data-id="element-451">
            <div className="h-px bg-border-accent flex-grow" data-id="element-452" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-453">
              ◆ Opening ◆
            </span>
            <div className="h-px bg-border-accent flex-grow" data-id="element-454" />
          </div>
        </FadeIn>

        <div className="space-y-8 font-body text-lg leading-relaxed text-text-primary" data-id="element-455">
          {/* Opening narrative — grouped for smooth reading */}
          <FadeIn data-id="element-456">
            <p data-id="element-457">
              There are moments the news covers for 48 hours. And then we bury
              them under the next news cycle.
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-458">
            <p data-id="element-459">
              On September 10, 2025, a man was killed in a university auditorium
              in Utah while defending the right to debate ideas out loud.
            </p>
          </FadeIn>

          <FadeIn delay={0.15} data-id="element-460">
            <p className="font-display text-2xl md:text-3xl font-bold text-text-primary py-2" data-id="element-461">
              His name was Charlie Kirk.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-462">
            <p data-id="element-463">
              What followed — the reactions, the vigils, the complicit silence
              of certain media outlets, the indignation of millions — lasted
              less than a week in the public conversation.
            </p>
          </FadeIn>

          {/* Blockquote */}
          <FadeIn delay={0.25} data-id="element-464">
            <div className="border-l-4 border-accent-primary bg-surface p-6 md:p-8 my-12" data-id="element-465">
              <p className="font-display text-xl md:text-2xl italic text-text-primary leading-relaxed m-0" data-id="element-466">
                This book exists because some stories deserve more than 48
                hours.
              </p>
            </div>
          </FadeIn>

          {/* Mid-section CTA — secondary, less aggressive */}
          <FadeIn delay={0.3} data-id="element-467">
            <div className="flex flex-col items-center my-4" data-id="element-468">
              <Button href="#offer" variant="secondary" className="w-full md:w-auto text-sm md:text-base" data-id="element-469">
                Get The Book That Fills The Gap &rarr;
              </Button>
              <p className="font-ui text-xs text-text-muted mt-3 tracking-wide" data-id="element-470">
                Digital. Immediate. Permanent.
              </p>
            </div>
          </FadeIn>

          {/* Divider between Opening and Pain */}
          <FadeIn data-id="element-471">
            <div className="flex items-center gap-4 mt-20 mb-14" data-id="element-472">
              <div className="h-px bg-border-accent flex-grow" data-id="element-473" />
              <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-474">
                ◆ The Pain ◆
              </span>
              <div className="h-px bg-border-accent flex-grow" data-id="element-475" />
            </div>
          </FadeIn>

          {/* "You felt it" — emotional anchor */}
          <FadeIn data-id="element-476">
            <p className="font-display text-3xl md:text-4xl font-bold text-text-primary" data-id="element-477">
              You felt it.
            </p>
          </FadeIn>

          {/* Emotional escalation — grouped for rhythm */}
          <FadeIn delay={0.1} data-id="element-478">
            <div className="space-y-6" data-id="element-479">
              <p data-id="element-480">
                That strange discomfort when a story this big disappears from
                the feed in seventy-two hours.
              </p>
              <p data-id="element-481">
                When you realize the headlines were written for the click — not
                for the understanding.
              </p>
              <p data-id="element-482">
                When the people who should have spoken up went quiet. And the
                people who spoke said nothing of substance.
              </p>
            </div>
          </FadeIn>

          {/* Desire — what they wanted */}
          <FadeIn delay={0.15} data-id="element-483">
            <div className="space-y-6" data-id="element-484">
              <p className="text-text-primary font-medium" data-id="element-485">
                You wanted the full picture. You wanted context. History. Depth.
              </p>
              <p data-id="element-486">You wanted someone to take this seriously.</p>
            </div>
          </FadeIn>

          {/* Contrast — what they got instead */}
          <FadeIn delay={0.2} data-id="element-487">
            <p data-id="element-488">
              And instead, you got trending hashtags and a news cycle that moved
              on to the next outrage before the echo of the first had faded.
            </p>
          </FadeIn>

          {/* The bridge — key selling line */}
          <FadeIn delay={0.25} data-id="element-489">
            <p className="font-display text-xl md:text-2xl italic text-accent-soft leading-relaxed mt-8" data-id="element-490">
              That gap — between what happened and what was actually explained —
              is exactly what this book was built to fill.
            </p>
          </FadeIn>

          {/* Closing CTA — strong, primary, with card treatment */}
          <FadeIn delay={0.3} data-id="element-491">
            <div className="flex flex-col items-center mt-16 bg-surface border border-border-default rounded-sm p-10 text-center" data-id="element-492">
              <p className="font-display text-xl italic text-text-secondary mb-6" data-id="element-493">
                Don't let it disappear.
              </p>
              <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-494">
                Own The Memorial &rarr;
              </Button>
              <p className="font-ui text-xs text-text-muted mt-4 tracking-wide" data-id="element-495">
                Instant access. Permanent download.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}